import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_MOBILE_APP_SETTINGS_REQUEST = 'FETCH_MOBILE_APP_SETTINGS_REQUEST';
export const FETCH_MOBILE_APP_SETTINGS_SUCCESS = 'FETCH_MOBILE_APP_SETTINGS_SUCCESS';
export const FETCH_MOBILE_APP_SETTINGS_FAILURE = 'FETCH_MOBILE_APP_SETTINGS_FAILURE';

export const UPDATE_MOBILE_APP_SETTINGS_REQUEST = 'UPDATE_MOBILE_APP_SETTINGS_REQUEST';
export const UPDATE_MOBILE_APP_SETTINGS_SUCCESS = 'UPDATE_MOBILE_APP_SETTINGS_SUCCESS';
export const UPDATE_MOBILE_APP_SETTINGS_FAILURE = 'UPDATE_MOBILE_APP_SETTINGS_FAILURE';

export const CLEAR_MOBILE_APP_SETTINGS = 'CLEAR_MOBILE_APP_SETTINGS';

const baseURL = 'agencies/crm/mobile-app-settings';

export const fetchMobileAppSettings = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_MOBILE_APP_SETTINGS_REQUEST, FETCH_MOBILE_APP_SETTINGS_SUCCESS, FETCH_MOBILE_APP_SETTINGS_FAILURE],
  },
});

export const updateMobileAppSettings = (mobileAppSettings: IMobileAppSettingsRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'put',
    authenticated: true,
    body: mobileAppSettings,
    types: [UPDATE_MOBILE_APP_SETTINGS_REQUEST, UPDATE_MOBILE_APP_SETTINGS_SUCCESS, UPDATE_MOBILE_APP_SETTINGS_FAILURE],
  },
});

export const clearMobileAppSettings = () => ({
  type: CLEAR_MOBILE_APP_SETTINGS,
});
